import { type FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router";
import { useSignViewerUrl } from "@noa/api-client";
import { Spin, Text } from "~/components/ui";
import appConfig from "~/configs/app";

export const DocumentViewerScreen: FunctionComponent = () => {
  const { "*": blobPath } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const { signedUrl, isLoadingSignedUrl, isErrorSignedUrl, errorSignedUrl } = useSignViewerUrl(blobPath);
  const [iframeReady, setIframeReady] = useState(false);

  const handleIframeLoad = () => setIframeReady(true);

  if (isErrorSignedUrl && errorSignedUrl) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Text tone="danger">{t(errorSignedUrl.i18nKey)}</Text>
      </div>
    );
  }

  const fragment = location.hash || "";
  const pdfUrl = signedUrl ? `${appConfig.apiBaseUrl}${signedUrl}${fragment}` : null;
  const showSpinner = isLoadingSignedUrl || !pdfUrl || !iframeReady;

  return (
    <>
      {showSpinner && (
        <div className="absolute inset-0 flex h-screen items-center justify-center">
          <Spin size="large" />
        </div>
      )}
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          onLoad={handleIframeLoad}
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
            visibility: iframeReady ? "visible" : "hidden",
          }}
          title={blobPath}
        />
      )}
    </>
  );
};
